if (!customElements.get('collection-menu-shelf')) {
  customElements.define('collection-menu-shelf', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.viewport = this.querySelector('[data-shelf-viewport]');
      this.previous = this.querySelector('[data-shelf-previous]');
      this.next = this.querySelector('[data-shelf-next]');
      this.controls = this.querySelector('[data-shelf-controls]');
      if (!this.viewport || !this.previous || !this.next || !this.controls) return;

      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const update = () => this.update();
      this.viewport.addEventListener('scroll', update, { ...options, passive: true });
      this.previous.addEventListener('click', (event) => {
        event.stopPropagation();
        this.advance(-1);
      }, options);
      this.next.addEventListener('click', (event) => {
        event.stopPropagation();
        this.advance(1);
      }, options);
      this.addEventListener('keydown', (event) => this.onKeydown(event), options);
      this.addEventListener('focusin', (event) => this.reveal(event.target), options);
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.viewport);
        for (const card of this.viewport.children) this.resizeObserver.observe(card);
      } else {
        window.addEventListener('resize', update, options);
      }
      this.update();
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.resizeObserver?.disconnect();
    }

    update() {
      const maximum = this.maximum();
      const hideControls = maximum <= 1;
      const disablePrevious = this.viewport.scrollLeft <= 1;
      const disableNext = this.viewport.scrollLeft >= maximum - 1;
      const focused = this.ownerDocument.activeElement;
      if ((hideControls && this.controls.contains(focused)) ||
        (disablePrevious && focused === this.previous) ||
        (disableNext && focused === this.next)) {
        this.viewport.focus({ preventScroll: true });
      }
      this.controls.hidden = hideControls;
      this.previous.disabled = disablePrevious;
      this.next.disabled = disableNext;
    }

    maximum() {
      return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }

    scrollTo(left) {
      this.viewport.scrollTo({
        left: Math.max(0, Math.min(left, this.maximum())),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    advance(direction) {
      const current = this.viewport.scrollLeft;
      const left = this.viewport.getBoundingClientRect().left;
      const stops = Array.from(this.viewport.children, (card) =>
        Math.min(this.maximum(), card.getBoundingClientRect().left - left + current)
      );
      const target = direction > 0
        ? stops.find((stop) => stop > current + 1) ?? this.maximum()
        : stops.reverse().find((stop) => stop < current - 1) ?? 0;
      this.scrollTo(target);
    }

    onKeydown(event) {
      const direction = { ArrowLeft: -1, ArrowRight: 1 }[event.key];
      if (direction || event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        event.stopPropagation();
        if (direction) this.advance(direction);
        else this.scrollTo(event.key === 'Home' ? 0 : this.maximum());
      } else if ((event.key === 'Enter' || event.key === ' ') &&
        (event.target === this.previous || event.target === this.next)) {
        event.stopPropagation();
      }
    }

    reveal(target) {
      const card = target.closest('.menu__block');
      if (!card || card.parentElement !== this.viewport) return;
      const bounds = card.getBoundingClientRect();
      const viewport = this.viewport.getBoundingClientRect();
      if (bounds.left < viewport.left) this.scrollTo(this.viewport.scrollLeft + bounds.left - viewport.left);
      else if (bounds.right > viewport.right) this.scrollTo(this.viewport.scrollLeft + bounds.right - viewport.right);
    }
  });
}
